/**
 * Border radius tokens in pixels
 * @see [Figma Radius](https://www.figma.com/design/56sl8nzEsswtU7qNn6drvG/Kos-v1?node-id=6-3)
 */
export const radius = {
  none: 0, // 0px
  '2xs': 1, // 1px
  xs: 2, // 2px
  sm: 4, // 4px
  md: 6, // 6px
  lg: 8, // 8px
  xl: 12, // 12px
  '2xl': 16, // 16px
  '3xl': 24, // 24px
  '4xl': 32, // 32px
  full: 9999, // 9999px
};
